import { FormFieldValuesUI } from "Backend";
import { FormField, FormFieldValues } from "generated/graphql";

export function isFormValueAnswered(
  field: FormField,
  formValue: FormFieldValues | FormFieldValuesUI | undefined
): boolean {
  return !!(
    formValue &&
    (field.promptYesNo
      ? formValue.yesNoValue !== undefined && formValue.yesNoValue !== null
      : formValue.valueGroups.length > 0)
  );
}
